import { Injectable } from '@angular/core';
import encoding from 'text-encoding';
import Utils from 'src/app/shared/fgi-utils';

@Injectable({
  providedIn: 'root'
})
export class FileUtilsService {

  static readonly TEXT_PLAIN = 'text/plain;charset=UTF-8';
  static readonly TEXT_CSV = 'text/csv;charset=UTF-8';
  static readonly APPLICATION_JSON = 'application/json;charset=UTF-8';
  static readonly APPLICATION_PDF = 'application/pdf';
  static readonly APPLICATION_OCTEC = "application/octet-stream";

  // le um arquivo, fazendo tratamento de encodings
  lerConteudo(fileReader: FileReader) {

    const textDecoderUTF8 = new encoding.TextDecoder('UTF-8');

    let conteudoArquivo: string;
    conteudoArquivo = textDecoderUTF8.decode(<BufferSource>fileReader.result);

    if (conteudoArquivo && conteudoArquivo === '') {
      return '';
    }
    return conteudoArquivo;
  }

  exportarArquivo(nomeArquivo: string, conteudo: string, tipoConteudo: string) {

   //  const blob = new Blob(['\ufeff', conteudo], { 'type': tipoConteudo });

    const blob = new Blob([conteudo], { 'type': tipoConteudo});

    // GDMS - retirado por incompatibilidade na migração para angular 13 e IE
    // if (navigator.msSaveBlob) { // IE 10+
    //  navigator.msSaveBlob(blob, nomeArquivo);
    //} else {
      const link = document.createElement('a');
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', nomeArquivo);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
     // }
    }
  }

  exportarArquivoUTF8(nomeArquivo: string, conteudo: string, tipoConteudo: string) {

     const blob = new Blob(['\ufeff', conteudo], { 'type': tipoConteudo});

     // GDMS - retirado por incompatibilidade na migração para angular 13 e IE
     //if (navigator.msSaveBlob) { // IE 10+
     //  navigator.msSaveBlob(blob, nomeArquivo);
     //} else {
       const link = document.createElement('a');
       if (link.download !== undefined) { // feature detection
         // Browsers that support HTML5 download attribute
         const url = URL.createObjectURL(blob);

         link.setAttribute('href', url);
         link.setAttribute('download', nomeArquivo);
         link.style.visibility = 'hidden';
         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
      // }
     }
   }
}
